import React, { useState } from "react";
import { X, Send, Mail } from "lucide-react";
import { dealsApi } from "../api";
import { getDealPdfBase64 } from "../utils/dealPdf";
import { toast } from "sonner";

// Modal to email a deal-sheet PDF to an investor from deals@dscrdaily.com
export default function EmailDealModal({ deal, onClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  if (!deal) return null;

  const send = async () => {
    if (!email || !email.includes("@")) { toast.error("Enter a valid investor email"); return; }
    setBusy(true);
    try {
      const { base64, filename } = getDealPdfBase64(deal);
      const res = await dealsApi.emailSheet({
        toEmail: email.trim(), dealAddress: deal.address || "this property",
        message, pdfBase64: base64, filename,
      });
      if (res.sent) toast.success(`Deal sheet sent to ${email}`);
      else toast.success("Deal sheet queued — will send once email is configured.");
      onClose();
    } catch (e) { toast.error("Could not send the deal sheet. Try again."); }
    finally { setBusy(false); }
  };

  return (
    <div onClick={onClose} data-testid="email-deal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.82)", backdropFilter: "blur(6px)", zIndex: 260, display: "flex", alignItems: "center", justifyContent: "center", padding: "1.5rem" }}>
      <div onClick={(e) => e.stopPropagation()} className="card" style={{ background: "#111015", width: "100%", maxWidth: 460, padding: "2.4rem", position: "relative", borderColor: "rgba(201,162,75,0.2)" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 18, right: 18, background: "none", border: "none", color: "var(--muted)", cursor: "pointer" }}><X size={20} /></button>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "0.4rem", color: "var(--gold)" }}><Mail size={18} /><span className="eyebrow" style={{ color: "var(--gold)" }}>Email Deal Sheet</span></div>
        <h3 className="font-serif" style={{ fontSize: "1.5rem", marginBottom: "0.3rem" }}>Send to an investor</h3>
        <p className="body-text" style={{ fontSize: "0.82rem", marginBottom: "1.2rem" }}>Attaches the PDF for <b style={{ color: "var(--text)" }}>{deal.address}</b> and sends it from deals@dscrdaily.com.</p>
        <div style={{ display: "grid", gap: "0.8rem" }}>
          <input className="field" data-testid="email-deal-recipient" type="email" placeholder="Investor email address *" value={email} onChange={(e) => setEmail(e.target.value)} />
          <textarea className="field" data-testid="email-deal-message" rows={3} style={{ resize: "vertical" }} placeholder="Add a personal note (optional)" value={message} onChange={(e) => setMessage(e.target.value)} />
          <button className="btn-gold" data-testid="email-deal-send" onClick={send} disabled={busy} style={{ width: "100%" }}><Send size={14} /> {busy ? "Sending…" : "Send Deal Sheet"}</button>
        </div>
      </div>
    </div>
  );
}
